import discardInvitationOption from './actions/discardInvitationOption';
import saveInvitationOption from './orchestration/saveInvitationOption';
import InvitationFull from './components/InvitationFull';
import isInvitationOptionDirty from './utils/isInvitationOptionDirty';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
var InvitationOption = {
    key: 'invitation',
    titleStringKey: 'optionTitle_invitation',
    searchTermsStringKey: 'optionTitle_invitation',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InvitationFull, null); },
        isDirty: isInvitationOptionDirty,
        onSave: saveInvitationOption,
        onDiscard: discardInvitationOption,
    },
    isHidden: function () { return !isControlFeatureEnabled('cal-event-invitation-setting'); },
};
export default InvitationOption;
//# sourceMappingURL=InvitationOption.js.map